export const APPLICATION = 'APPLICATION';
export const application = 'application';
export const DATE = 'DATE';
export const CHANGE_SELECTED_MIN_DATE = 'CHANGE_SELECTED_MIN_DATE';
export const CHANGE_SELECTED_MAX_DATE = 'CHANGE_SELECTED_MAX_DATE';
